// localized-date.pipe.ts
import { Pipe, PipeTransform } from '@angular/core';
import { formatDate } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'localizedDate',
  pure: false,
  standalone: false // important: updates automatically when language changes
})
export class LocalizedDatePipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(value: Date | string | number, format: string = 'medium'): string {
    let lang = this.translate.currentLang || this.translate.getDefaultLang() || 'en';

    return formatDate(value, format, lang);
  }
}
